import { useQuery } from '@tanstack/react-query'

import { useOrganizacion } from '@/core/providers/OrganizacionProvider'
import { useSupabase } from '@/lib/supabase-context'

/**
 * Ids de los clientes de la organización con una clave de ARCA vigente. La app no lee
 * `claves_clientes`: la RPC filtra la organización y los organismos y devuelve solo `cliente_id`.
 */
export const useClientesConClaveArca = (enabled = true) => {
  const { supabase } = useSupabase()
  const { membresia } = useOrganizacion()
  const orgId = membresia?.organizacion_id
  return useQuery({
    queryKey: ['claves-cliente', 'con-arca', orgId],
    queryFn: async () => {
      const { data, error } = await supabase!.rpc('clientes_con_clave_arca', { p_org_id: orgId! })
      if (error) throw error
      return new Set(data.map((c) => c.cliente_id))
    },
    enabled: enabled && !!supabase && !!orgId,
  })
}
